import { generatePath } from 'react-router-dom';
import { ASSIGN_PLAYLIST_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../constants/Navigation';
export const ASSIGNMENT_IDS_PARAM = 'assignmentIds';
export const getAssignPlaylistUrl = ({
  portalId,
  playlistId,
  assignmentIds
}) => {
  const path = generatePath(ASSIGN_PLAYLIST_URL_FRAGMENT, {
    portalId,
    playlistId
  });
  if (assignmentIds) {
    const searchParams = new URLSearchParams(assignmentIds.map(s => [ASSIGNMENT_IDS_PARAM, s.toString()]));
    return `${path}?${searchParams.toString()}`;
  } else return path;
};
export const getPortalAssignmentsUrl = ({
  playlistId,
  documentFragmentLink = false
}) => {
  return `${generatePath(PLAYLIST_URL_FRAGMENT, {
    playlistId
  })}${documentFragmentLink ? '#playlist-assignments' : ''}`;
};
export const getAssignmentsForPortalUrl = ({
  portalId,
  playlistId,
  documentFragmentLink = false
}) => {
  return `${generatePath(PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, {
    portalId,
    playlistId
  })}${documentFragmentLink ? '#playlist-assignments' : ''}`;
};